import { render } from "./DataTable.vue?vue&type=template&id=2c8e3d92"
import script from "./DataTable.vue?vue&type=script&lang=ts"
export * from "./DataTable.vue?vue&type=script&lang=ts"
script.render = render

export default script